import { useState, useEffect, useContext } from "react";
import HeaderDashboard from "../../Components/HeaderDashboard";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider"
import { CabTransaction } from "../../Services/ReservationsApi";

const AllTransactions = () => {
      const { name, userName, roles } = useContext(AuthContext);
    const userRole = roles?.[0];

const isTmcAdmin = roles?.includes("TMC Operations");
const isCorpTravel = roles?.includes("Corporate Traveller");
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        bookingRefNo: "",
        bookingStatus: "",
    });
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            // changeMonth: true,
            // changeYear: true,
            // maxDate: new Date(),
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
    }, [filters.fromDate]);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                ReferenceNo: filters.bookingRefNo,
                BookingStatus: filters.bookingStatus,
                UserName: userName,
            };
            //console.log("requestBody:", requestBody);
            const data = await CabTransaction(requestBody);

            const list = data?.allTransactions || [];
            setTransactions(list);

        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard />

            <div className="toolbar py-2" id="kt_toolbar">
                <div className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="page-title d-flex align-items-center flex-wrap">
                            <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Cab</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">All Transactions</li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="flex-shrink-0 me-2 d-none-mob">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a href='/Dashboard'>
                                        <img src='/assets/images/back.png' width={30} /> </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section className="wraper">
                <div className="box_shadow mt-14">
                     {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>Organization </label>
                                <select
                                    className="form-select form-select-solid" name="paymentStatus" alue={filters.paymentStatus}
                                    onChange={handleChange}>
                                    <option value="">- All -</option>
                                </select>

                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Company </label>
                                <select
                                    className="form-select form-select-solid" name="paymentStatus" alue={filters.paymentStatus}
                                    onChange={handleChange}>
                                    <option value="">- All -</option>
                                </select>

                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Legal Entity </label>
                                <select
                                    className="form-select form-select-solid" name="paymentStatus" alue={filters.paymentStatus}
                                    onChange={handleChange}>
                                    <option value="">- All -</option>
                                </select>

                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Corporate Traveller </label>
                                <select
                                    className="form-select form-select-solid" name="paymentStatus" alue={filters.paymentStatus}
                                    onChange={handleChange}>
                                    <option value="">- All -</option>
                                </select>
                            </div>
                            
                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>

                    )}
                     {roles?.includes("Corp Travel Manager","Corp Administrator") && (
                        <div className="row">
                            {/* <div className="col-md-3 mb-1">
                                <label>Orgenization </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Company </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Entity </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Department </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Branch </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Cost Center </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Emp Id  </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Pax Name </label>
                                <input className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div> */}
                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                     )}
                    {roles?.includes("Corporate Traveller") && (
                        <div className="row">

                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}

                </div>

                <div className="box_shadow mt-3">
                    <div className="table-responsive">
                        <table className="table table-striped align-middle">
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th className="ps-4">Sr No</th>
                                    <th>RefNo.</th>
                                    <th>Organization Name</th>
                                    <th>Travel Type</th>
                                    <th>PickUp Location</th>
                                    <th>Drop Location</th>
                                    <th>Start Date</th>
                                    {/* <th>End Date</th>
                                    <th>PickUp Time</th> */}
                                    <th>Cab Type</th>
                                    <th>Status</th>
                                    <th>CreatedBy</th>
                                    <th>CreatedOn</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.length > 0 ? (
                                    transactions.map((item, index) => (
                                        <tr key={index}>
                                            <td className="ps-4">{index + 1}</td>
                                            <td><span
                                                style={{ color: "red", cursor: "pointer" }}
                                                onClick={() => navigate(`/reservations/Cab/TransactionsDetails?referenceNo=${item.referenceNo}&id=${item.id}`)}
                                            >
                                                {item.referenceNo}
                                            </span>
                                            </td>
                                            <td>{item.organizationName} ({item.companyId})</td>
                                            <td>
                                                {{
                                                    "1": "Business Travel",
                                                    "2": "Personal Travel",
                                                    "3": "Guest Travel"
                                                }[item.travelType] || "N/A"}
                                            </td>
                                            <td>{item.fromLocation}</td>
                                            <td>{item.toLocation}</td>
                                            <td>{item.fromDate}</td>
                                            {/* <td>{item.toDate}</td>
                                            <td>{item.pickTime}</td> */}
                                            <td>{item.cabType}</td>
                                            <td>{item.status}</td>
                                            <td>{item.userName}</td>
                                            <td>{item.createdOn}</td>
                                            <td className="text-center">
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() =>
                                                        navigate(
                                                            `/reservations/Cab/TransactionsDetails?referenceNo=${item.referenceNo}&id=${item.id}`
                                                        )
                                                    }
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="14" className="text-center text-muted">
                                            {loading ? "Loading..." : "No records found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    );
};
export default AllTransactions;